var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMoneySmall = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M10.9748744,12.6793893 L13.0170854,12.6793893 C13.8532663,12.6793893 14.5286432,13.3206107 14.5286432,14.1145038 C14.5286432,14.9083969 13.8532663,15.5496183 13.0170854,15.5496183 L9.34271357,15.5496183 C8.94070352,15.5496183 8.61105528,15.8625954 8.61105528,16.2442748 C8.61105528,16.6259542 8.94070352,16.9389313 9.34271357,16.9389313 L11.2643216,16.9389313 L11.2643216,18.3053435 C11.2643216,18.6870229 11.5939698,19 11.9959799,19 C12.3979899,19 12.7276382,18.6870229 12.7276382,18.3053435 L12.7276382,16.9389313 L13.0251256,16.9389313 C14.6653266,16.9389313 16,15.6717557 16,14.1145038 C16,12.5572519 14.6653266,11.2900763 13.0251256,11.2900763 L10.9829146,11.2900763 C10.1467337,11.2900763 9.47135678,10.648855 9.47135678,9.85496183 C9.47135678,9.0610687 10.1467337,8.41984733 10.9829146,8.41984733 L14.5929648,8.41984733 C14.9949749,8.41984733 15.3246231,8.10687023 15.3246231,7.72519084 C15.3246231,7.34351145 14.9949749,7.03053435 14.5929648,7.03053435 L12.7356784,7.03053435 L12.7356784,5.69465649 C12.7356784,5.3129771 12.4060302,5 12.0040201,5 C11.6020101,5 11.2723618,5.3129771 11.2723618,5.69465649 L11.2723618,7.03816794 L10.9748744,7.03816794 C9.33467337,7.03816794 8,8.30534351 8,9.86259542 C8.0080402,11.4122137 9.34271357,12.6793893 10.9748744,12.6793893 Z"
  }));
};
export default SvgMoneySmall;